import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { scan } from "react-scan";
import App from "./App.tsx";
import "./globals.css";
import { initializeAuth } from "./api/axios.ts";
import { Providers } from "./providers.tsx";

scan({
	enabled: import.meta.env.DEV,
});

initializeAuth();

// biome-ignore lint/style/noNonNullAssertion: <explanation>
createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<Providers>
			<App />
		</Providers>
	</StrictMode>,
);
